import React, { ChangeEvent, Component, ReactNode } from 'react';
import { ChartState } from '../../../../redux/reducers/ChartReducer';
import CustomLoading from '../../../custom/CustomLoading';
import { SegmentItem } from '../../../../domain/chart/ChartDomains';
import { RootState } from '../../../../redux/store';
import { changeChart, changeChartEditorOptions, changeIsUpdate, clearChart } from '../../../../redux/actions/ChartActions';
import { enterComponent, leaveComponent } from '../../../../redux/actions/ComponentActions';
import { connect } from 'react-redux';
import { ConnectedProps } from 'react-redux/es/exports';
import FormicaInput from 'components/custom/FormicaInput';
import FormicaColorPalette from '../../../custom/color-palette/FormicaColorPalette';
import { ChartType } from '@trlogic/ui-pack';
import LanguageUtil from '../../../../util/LanguageUtil';

class DateHistogramAppearance extends Component<Props> {
  render() {
    return <div className={'flex w-full'}>{this.getAppearanceContent()}</div>;
  }

  private onChangeColorPalette = (color: string[]) => {
    const { segmentItem, onChangeSegmentItem } = this.props;
    if (segmentItem) {
      segmentItem.colorPalette = color;
      onChangeSegmentItem(segmentItem);
    }
  };

  private onChangeAppearanceName = (e: ChangeEvent<HTMLInputElement>) => {
    const { segmentItem, onChangeSegmentItem } = this.props;
    if (segmentItem?.segments.dateHistogram) {
      segmentItem.segments.dateHistogram.appearance.name = e.currentTarget.value;
      segmentItem.name = e.currentTarget.value;
      onChangeSegmentItem(segmentItem);
    }
  };

  private getAppearanceContent = (): ReactNode => {
    const {
      segmentItem,
      isBreakdown = false,
      chart: { chart },
    } = this.props;
    const dateHistogram = segmentItem?.segments.dateHistogram;
    if (dateHistogram == undefined) return <CustomLoading />;
    const { chartType } = this.props;
    if (chartType == ChartType.PIE || chartType == ChartType.DONUT) {
      return (
        <div className={`flex flex-col w-full gap-y-2 items-start `}>
          <p className={'text-lg text-primary'}>{LanguageUtil.get({ id: 'common.label.appearance', defaultMessage: 'Appearance' })}</p>
          <div className={'flex flex-col gap-y-1 w-full'}>
            <label className={'text-sm text-f-black-3 ml-1'}>{LanguageUtil.get({ id: 'common.label.name', defaultMessage: 'Name' })}</label>
            <FormicaInput
              id={'appearance-name'}
              value={dateHistogram.appearance.name}
              onChange={(e: ChangeEvent<HTMLInputElement>) => {
                this.onChangeAppearanceName(e);
              }}
              placeholder={LanguageUtil.get({ id: 'common.input.placeholder.name', defaultMessage: 'Name' })}
            />
          </div>
        </div>
      );
    }
    return (
      <div className={`flex flex-col w-full items-start `}>
        <p className={'text-lg text-primary font-semibold'}>{LanguageUtil.get({ id: 'common.label.appearance', defaultMessage: 'Appearance' })}</p>
        <div className={'flex flex-col gap-y-1 w-full'}>
          <label className={'text-sm text-f-black-3'}>{LanguageUtil.get({ id: 'common.label.name', defaultMessage: 'Name' })}</label>
          <FormicaInput
            id={'appearance-name'}
            value={dateHistogram.appearance.name}
            onChange={(e: ChangeEvent<HTMLInputElement>) => {
              this.onChangeAppearanceName(e);
            }}
            placeholder={LanguageUtil.get({ id: 'common.input.placeholder.name', defaultMessage: 'Name' })}
          />
        </div>
      </div>
    );
  };
}

interface Props extends ReduxProps {
  segmentItem: SegmentItem | null;
  onChangeSegmentItem: (segmentItem: SegmentItem) => void;
  chartType: ChartType;
  isBreakdown: boolean;
}

const mapStateToProps = (state: RootState) => ({
  chart: state.chart as ChartState,
});

const mapDispatchToProps = { changeChart, changeChartEditorOptions, changeIsUpdate, enterComponent, leaveComponent, clearChart };
const connector = connect(mapStateToProps, mapDispatchToProps);
type ReduxProps = ConnectedProps<typeof connector>;
export default connector(DateHistogramAppearance);
